type HandleSpecialCaseDetailArrays = {
  path: string
  items: Array<Record<string, unknown>> | string[] | null
}

export const handleSpecialCaseDetailArrays = ({
  path,
  items,
}: HandleSpecialCaseDetailArrays): string[] | null => {
  if (path === 'pallbearers') {
    if (!Array.isArray(items)) return null
    if (items.every((item) => typeof item === 'string')) {
      return items as string[]
    }
    return items
      .filter(
        (item): item is { name: string; type?: string } =>
          typeof item === 'object' &&
          item !== null &&
          typeof (item as Record<string, unknown>).name === 'string',
      )
      .filter((item) => item.type?.toLowerCase() !== 'honorary pallbearer')
      .map((item) => item.name)
  }

  if (path === 'honorary_pallbearers_from_relation') {
    if (!Array.isArray(items)) return null
    if (items.every((item) => typeof item === 'string')) {
      return []
    }
    return items
      .filter(
        (item): item is { name: string; type?: string } =>
          typeof item === 'object' &&
          item !== null &&
          typeof (item as Record<string, unknown>).name === 'string',
      )
      .filter((item) => item.type?.toLowerCase() === 'honorary pallbearer')
      .map((item) => item.name)
  }

  return items as string[] | null
}
